export const donorRoutes = [
  {
    path: "/donor/interest",
    component: () => import("@/views/Donor/DonorInterest.vue"),
  },
  {
    path: "/donor/register/privatedonor",
    component: () => import("@/views/Donor/DonorRegistration.vue"),
  },
  {
    path: "/donor/register/businessdonor",
    component: () => import("@/views/Donor/BusinessDonorRegistration.vue"),
  },
  {
    path: "/donor/update/privatedonor",
    component: () => import("@/views/Donor/DonorRegistration.vue"),
  },
  {
    path: "/donor/update/businessdonor",
    component: () => import("@/views/Donor/BusinessDonorRegistration.vue"),
  },
  {
    path: "/donor/dashboard/:userReference",
    component: () => import("@/views/Donor/AdminDashboard.vue"),
  },

  {
    path: "/donor/donationdetails/",
    component: () => import("@/views/Donor/DonationDetails.vue"),
  },

  {
    path: "/donor",
    component: () => import("@/views/Donor/List.vue"),
  },
  {
    path: "/donor/donorpayment",
    component: () => import("@/views/DonorPayment/List.vue"),
  },
  {
    path: "/donor/donorpayment/transactions",
    component: () => import("@/views/DonorPayment/TransactionsList.vue"),
  },
];
